import { FC, ReactNode } from "react";

import { IWrapper } from "@/components/Application/WrapperCenter";

interface IWrapperLeft extends IWrapper {
  children: ReactNode;
}

export const WrapperLeft: FC<IWrapperLeft> = (props) => {
  const className = `wrapper-left `;
  return <section className={className}>{props.children}</section>;
};
